import * as React from "react";
import classNames from "classnames";

export interface ISpecificationItem {
    url?: string;
    text: string;
}

export interface ISpecification {
    key: string;
    specifications: ISpecificationItem[];
}

export interface ISpecificationsListProps {
    specifications: ISpecification[];
    header?: string;
    className?: string;
}

const SpecificationsList: React.FC<ISpecificationsListProps> = props => {
    const { header, specifications, className } = props;
    const rootClasses = classNames("specifications-list", className);

    return (
        <div className={rootClasses}>
            <ul className="specifications-list__list">
                {props.header && (
                    <li className="specifications-list__header specifications-list__list-item">{header}</li>
                )}
                {specifications.map((item, index) => {
                    if (!item.specifications || !item.key || item.specifications.length === 0) {
                        return;
                    }

                    const values = item.specifications.map((subItem, subItemIndex) => {
                        if (!subItem || !subItem.text) {
                            return "";
                        }

                        const keyName = `${item.key.trim().replace(/\s/g, "")}-${subItemIndex}`;

                        if (subItem.url) {
                            return (
                                <a href={subItem.url} data-key={`${keyName}`} key={keyName}>
                                    {subItem.text}
                                </a>
                            );
                        }
                        return (
                            <span data-key={`${keyName}`} key={keyName}>
                                {subItem.text}
                            </span>
                        );
                    });

                    const valuesArray = values.map(value => value).filter(str => str !== "");

                    if (!valuesArray || valuesArray.length === 0) {
                        return;
                    }

                    return (
                        <li key={index} className="specifications-list__list-item">
                            <span className="specifications-list__list-item-key">{item.key}</span>
                            <span className="specifications-list__list-item-value">{valuesArray}</span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default SpecificationsList;
